<template>
  <modal class="alert-modal" :closeBtn="allowClose">
    <template v-slot:header> </template>
    <p class="error">
      {{ alertText }}
    </p>
    <template v-slot:footer></template>
  </modal>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import Modal from "../shared/Modal.vue";

export default defineComponent({
  components: {
    Modal,
  },
  props: {
    alertText: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    allowClose: true,
  }),
});
</script>

<style>
.alert-modal .modal-wrapper .modal-container .modal-body {
  min-height: 100px;
  padding: 1.563rem 1.5rem;
}

.alert-modal .modal-container {
  max-width: 400px;
}
.error {
  color: red;
}
</style>

<style scoped>
.footer-btns button {
  margin-left: 15px;
}
</style>
